const common = {
  // Nav
  nav_home: "หน้าหลัก",
  nav_tracking: "ติดตามพัสดุ",
  nav_admin: "ผู้ดูแลระบบ",
  nav_brand: "Sonic Express Services",

  // Home
  home_hero_title: "ติดตามพัสดุของคุณ",
  home_hero_subtitle: "ติดตามการจัดส่งของคุณแบบเรียลไทม์ทั่วโลก",
  home_search_placeholder: "SE-000000000",
  home_search_btn: "ติดตามเลย",
  home_features_title: "ทำไมต้องเลือก Sonic Express Services?",
  home_feature1_title: "อัปเดตแบบเรียลไทม์",
  home_feature1_desc: "รับสถานะพัสดุแบบสดทุกขั้นตอนของการเดินทาง",
  home_feature2_title: "ครอบคลุมทั่วโลก",
  home_feature2_desc: "ติดตามการจัดส่งใน 200+ ประเทศและดินแดนทั่วโลก",
  home_feature3_title: "แจ้งเตือนทันที",
  home_feature3_desc: "รับการแจ้งเตือนเมื่อสถานะพัสดุเปลี่ยนแปลง",
  home_stats_parcels: "พัสดุที่ติดตาม",
  home_stats_countries: "ประเทศที่ครอบคลุม",
  home_stats_satisfaction: "ความพึงพอใจของลูกค้า",
  home_recent_title: "การติดตามล่าสุด",
  home_no_recent: "ไม่มีประวัติการติดตาม",
  home_track_another: "ติดตามพัสดุอื่น",

  // Parcel Details
  parcel_title: "รายละเอียดพัสดุ",
  parcel_tracking_number: "หมายเลขติดตาม",
  parcel_status: "สถานะ",
  parcel_sender: "ผู้ส่ง",
  parcel_recipient: "ผู้รับ",
  parcel_weight: "น้ำหนัก",
  parcel_dimensions: "ขนาด",
  parcel_origin: "ต้นทาง",
  parcel_destination: "ปลายทาง",
  parcel_current_location: "ตำแหน่งปัจจุบัน",
  parcel_estimated_delivery: "กำหนดส่งโดยประมาณ",
  parcel_phone: "หมายเลขโทรศัพท์",
  parcel_delivery_address: "ที่อยู่จัดส่ง",
  parcel_timeline_title: "ไทม์ไลน์การจัดส่ง",
  parcel_not_found: "ไม่พบพัสดุ",
  parcel_not_found_desc: "เราไม่พบพัสดุที่มีหมายเลขติดตามนี้ กรุณาตรวจสอบและลองใหม่อีกครั้ง",
  parcel_back_home: "กลับหน้าหลัก",
  parcel_map_title: "ตำแหน่งปัจจุบัน",
  parcel_info_title: "ข้อมูลการจัดส่ง",

  // Status labels
  status_processing: "กำลังดำเนินการ",
  status_in_transit: "อยู่ระหว่างขนส่ง",
  status_out_for_delivery: "กำลังจัดส่ง",
  status_delivered: "จัดส่งแล้ว",
  status_exception: "มีปัญหา",

  // Admin
  admin_title: "แดชบอร์ดผู้ดูแลระบบ",
  admin_subtitle: "จัดการพัสดุทั้งหมดและข้อมูลการติดตาม",
  admin_add_parcel: "เพิ่มพัสดุใหม่",
  admin_search_placeholder: "ค้นหาด้วยหมายเลขติดตามหรือชื่อผู้รับ...",
  admin_col_tracking: "รหัสติดตาม",
  admin_col_recipient: "ผู้รับ",
  admin_col_status: "สถานะ",
  admin_col_location: "ตำแหน่งปัจจุบัน",
  admin_col_updated: "อัปเดตล่าสุด",
  admin_col_actions: "การดำเนินการ",
  admin_edit: "แก้ไข",
  admin_delete: "ลบ",
  admin_save: "บันทึกการเปลี่ยนแปลง",
  admin_cancel: "ยกเลิก",
  admin_confirm_delete: "คุณแน่ใจหรือไม่ว่าต้องการลบพัสดุนี้?",
  admin_modal_add_title: "เพิ่มพัสดุใหม่",
  admin_modal_edit_title: "แก้ไขพัสดุ",
  admin_field_tracking: "หมายเลขติดตาม",
  admin_field_status: "สถานะ",
  admin_field_sender: "ผู้ส่ง",
  admin_field_recipient: "ผู้รับ",
  admin_field_weight: "น้ำหนัก",
  admin_field_dimensions: "ขนาด",
  admin_field_origin: "ต้นทาง",
  admin_field_destination: "ปลายทาง",
  admin_field_location: "ตำแหน่งปัจจุบัน",
  admin_field_phone: "หมายเลขโทรศัพท์",
  admin_field_delivery_address: "ที่อยู่จัดส่ง",
  admin_field_lat: "ละติจูด",
  admin_field_lng: "ลองจิจูด",
  admin_field_estimated: "กำหนดส่งโดยประมาณ",
  admin_total_parcels: "พัสดุทั้งหมด",
  admin_in_transit: "อยู่ระหว่างขนส่ง",
  admin_delivered: "จัดส่งแล้ว",
  admin_processing: "กำลังดำเนินการ",
  admin_no_parcels: "ไม่พบพัสดุ",
  admin_password_label: "รหัสผ่านผู้ดูแลระบบ",
  admin_password_placeholder: "กรอกรหัสผ่านผู้ดูแลระบบ",
  admin_login_btn: "เข้าสู่ระบบ",
  admin_login_title: "เข้าสู่ระบบผู้ดูแลระบบ",
  admin_login_error: "รหัสผ่านไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
  admin_logout: "ออกจากระบบ",

  // Footer
  footer_desc: "พันธมิตรที่เชื่อถือได้ของคุณสำหรับการติดตามพัสดุและโซลูชันโลจิสติกส์ทั่วโลก",
  footer_quick_links: "ลิงก์ด่วน",
  footer_contact: "ติดต่อเรา",
  footer_email: "sonicexpresservices@gmail.com",
  footer_rights: "สงวนลิขสิทธิ์",
  footer_privacy: "นโยบายความเป็นส่วนตัว",
  footer_terms: "ข้อกำหนดการให้บริการ",

  // Tracking page hardcoded strings
  tracking_number_label: "หมายเลขติดตาม",
  tracking_live_active: "ติดตามแบบสด",
  tracking_delivery_details: "รายละเอียดการจัดส่ง",
  tracking_shipment_info: "ข้อมูลพัสดุ",
  tracking_looking_up: "กำลังค้นหาพัสดุของคุณ...",
  tracking_checking: "กำลังตรวจสอบหมายเลขติดตาม",
  tracking_invalid_format: "รูปแบบหมายเลขติดตามไม่ถูกต้อง",
  tracking_invalid_desc: "หมายเลขติดตามนี้ไม่อยู่ในรูปแบบที่ถูกต้อง",
  tracking_invalid_format_hint: "หมายเลขติดตาม Sonic Express มีรูปแบบดังนี้:",
  tracking_invalid_copy_hint: "กรุณาตรวจสอบให้แน่ใจว่าคุณคัดลอกหมายเลขติดตามครบถ้วน รวมถึงคำนำหน้า SE-",
  tracking_try_again: "ลองใหม่อีกครั้ง",
  tracking_not_registered: "ยังไม่ได้ลงทะเบียนพัสดุ",
  tracking_not_registered_desc: "หมายเลขติดตามนี้ยังไม่ได้ลงทะเบียนหรือไม่มีในระบบของเรา",
  tracking_not_registered_hint: "กรุณาตรวจสอบหมายเลขติดตามอีกครั้ง หรือติดต่อผู้ส่งเพื่อยืนยันว่าได้ลงทะเบียนการจัดส่งแล้ว",

  // Shipment progress stage labels
  stage_processing: "กำลังดำเนินการ",
  stage_in_transit: "อยู่ระหว่างขนส่ง",
  stage_out_for_delivery: "กำลังจัดส่ง",
  stage_delivered: "จัดส่งแล้ว",
  progress_current_location: "ตำแหน่งปัจจุบัน",
  progress_action_required: "อาจต้องดำเนินการ",
  progress_exception_desc: "พัสดุของคุณอาจอยู่ระหว่างการตรวจสอบศุลกากรหรือต้องการเอกสารเพิ่มเติม ทีมงานของเรากำลังดำเนินการอยู่ กรุณาติดต่อฝ่ายสนับสนุนเพื่อรับข้อมูลล่าสุด",
  progress_complete: "เสร็จสิ้น",

  // Timeline
  timeline_origin: "ต้นทาง",
  timeline_destination: "ปลายทาง",
  timeline_live: "สด",

  // Language
  lang_en: "English",
  lang_zh: "中文",
  lang_th: "ภาษาไทย",
};

export default common;
